import type { Workpiece } from "@tosize/shapes/src/types/workpiece";
import { useEffect } from "react";
import { useCardContext } from "../context/CardContext";
import { useConfig } from "../context/ConfigContext";
import { usePostDataContext } from "../context/PostDataContext";
import useFinishes from "../hooks/useFinishes";
import useProducts from "../hooks/useProducts";
import useShapes from "../hooks/useShapes";

export function OutgoingDataResolver() {
	const { onDataChange } = useConfig();
	const { data, workpiece, finishSwitchChecked, canvasSettings } = usePostDataContext();
	const { showVisualisation, setShowVisualisation } = useCardContext();
	const { productData } = useProducts();
	const { shape } = useShapes();
	const { finishInputs } = useFinishes();

	// biome-ignore lint/correctness/useExhaustiveDependencies: config can't be added as a dependency
	useEffect(() => {
		onDataChange?.({
			productId: data?.product,
			workpiece: {
				...workpiece,
				// Convert all values to numbers
				shape_dimensions: workpiece.shape_dimensions
					? Object.entries(workpiece.shape_dimensions).reduce(
							(acc, [key, value]) => Object.assign(acc, { [key]: Number(value) }),
							{},
						)
					: undefined,
			} as unknown as Workpiece,
			thickness: productData?.thickness,
			grainType: productData?.grain_type ?? undefined,
			shape,
			finishInputs,
			view: canvasSettings?.view,
			currentField: canvasSettings?.field,
			open: showVisualisation,
			setOpen: setShowVisualisation,
			modus: finishSwitchChecked ? "finishes" : "dimensions",
		});
	}, [
		canvasSettings?.field,
		canvasSettings?.view,
		data?.product,
		finishInputs,
		finishSwitchChecked,
		productData?.grain_type,
		productData?.thickness,
		shape,
		showVisualisation,
		workpiece,
		setShowVisualisation,
	]);

	return null;
}
